import { render, staticRenderFns } from "./MeasurementRoomEdit.vue?vue&type=template&id=2e50f80b&scoped=true&"
import script from "./MeasurementRoomEdit.vue?vue&type=script&lang=js&"
export * from "./MeasurementRoomEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e50f80b",
  null
  
)

export default component.exports